import { gql } from '@apollo/client';

export const CONFIRM_EMAIL = gql`
  mutation confirmEmail {
    confirmation(input: $input)
      @rest(type: "ConfirmedMail", path: "/v4/auth/confirm", method: "POST")
  }
`;
